<template>
  <div id="g-page" >
    <table class="screen">
      <tr>
        <td id="screen-row1" colspan="1"> 
          <!--MOVES THE VIEW BELOW THE MAIN MENU-->
        </td>
      </tr>
      <!-- TITLE -->
      <tr>
        <td class="screen-table-td">
          <table class="section-table" align="center">
            <tr>
              <td id="title-left" class="radius-single-left-field-left-top radius-single-left-field-left-bottom radius-single-left-field-right-top radius-single-left-field-right-bottom" >
                  <p>{{ $t("tests.title") }} <!--Medical Test Results--></p>
              </td>
              <td id="title-right" class="radius-single-right-field-left-top radius-single-right-field-left-bottom radius-single-right-field-right-top radius-single-right-field-right-bottom">
                <!--Please be aware, if your test results are not what you expect, you may want to ask to be tested again. Sometimes mistakes can occur, usually because of errors in collecting, storing, or processing lab samples.-->
                {{ $t("tests.instructions") }}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      
      <tr>
        <td class="screen-table-td">
          <div style="height:10px;" />
          <table class="section-table" border="0" align="center">
            <!--<tr v-if="isMobile==false">
              <td class="test-td-header radius-single-left-field-left-top"></td>
              <td colspan="3" class="test-td-header"></td>
              <td class="test-td-header radius-single-right-field-right-top"></td>
            </tr>-->
            <!-- MOBILE VIEW -->
            <tr v-if="isMobile">
              <!-- MOBILE TEST VIEW -->
              <td colspan="5">                
                <div v-if="tests.length == 0" >
                  <table width="100%" border="0">
                    <tr>
                      <td class="test-td-test-item-header"> {{ $t("tests.noResults") }} <!--No tests results found.--></td>
                    </tr>
                  </table>
                </div>
                <div v-else>
                  <div v-for="test in tests" :key="test.medicalTestId" >
                    <table width="100%" border="0">
                      <tr>
                        <td class="test-td-test-left" colspan="2"> {{ test.test }} </td>
                      </tr>
                      <tr>
                        <td class="test-td-header"> {{ $t("tests.dateOrdered") }} <!--Date Ordered--> </td>
                        <td class="test-td-test-center"> {{ test.dateOrdered }} </td>
                      </tr>
                      <tr>
                        <td class="test-td-header"> {{ $t("tests.datePerformed") }} <!--Date Performed--> </td>
                        <td class="test-td-test-center"> {{ test.datePerformed }} </td>
                      </tr>
                      <tr>
                        <td class="test-td-header"> {{ $t("tests.dateOfResults") }} <!--Date of Results--> </td>
                        <td class="test-td-test-center"> {{ test.dateOfResults }} </td>
                      </tr>
                      <tr>
                        <td class="test-td-header"> {{ $t("tests.dateResultsReceived") }} <!--Date Results Received--></td>
                        <td class="test-td-test-center"> {{ test.dateResultsReceived }} </td>
                      </tr>
                      <tr>
                        <td class="test-td-test-left" colspan="5">
                          <input type="button" 
                            class="dialog-input-button" 
                            v-on:click="onHideShowTest(test.medicalTestId)"
                            v-bind:value="$t('tests.showHide')"><!--'Show / Hide Test Results'-->
                        </td>
                      </tr>
                      <tr>
                        <td colspan="5">
                          <div :id="'div' + test.medicalTestId" class="is-hidden">
                            <table border="0" style="width:100%">
                              <tr v-for="item in test.items" :key="item.medicalTestId">
                                <td class="test-td-test-item-left">{{ $t("tests.item") }} :&nbsp; <!--Item--> {{ item.item }} </td>
                                <td class="test-td-test-item">{{ $t("tests.flag") }} :&nbsp;<!--Flag--> {{ item.flag }} </td>
                                <td class="test-td-test-item border-m">{{ $t("tests.value") }} :&nbsp;<!--Value--> {{ item.value }} </td>
                              </tr>
                            </table>
                          </div>
                          <div style="height:10px" />
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
            <!-- DESKTOP VIEW -->
            <tr v-else>
              <td colspan="5">                
                <div v-if="tests.length == 0" >
                  <table width="100%" border="0">
                    <tr>
                      <td class="test-td-test-item-header"> {{ $t("tests.noResults") }} </td>
                    </tr>
                  </table>
                </div>
                <div v-else>
                  <div v-for="test in tests" :key="test.medicalTestId">
                    <table width="100%" border="0">
                      <tr v-if="isMobile==false">
                        <td class="test-td-header radius-single-left-field-left-top"></td>
                        <td colspan="3" class="test-td-header"></td>
                        <td class="test-td-header radius-single-right-field-right-top"></td>
                      </tr>
                      <tr>
                        <td class="test-td-header"> </td>
                        <td class="test-td-header"> {{ $t("tests.dateOrdered") }} </td>
                        <td class="test-td-header"> {{ $t("tests.datePerformed") }} </td>
                        <td class="test-td-header"> {{ $t("tests.dateOfResults") }}</td>
                        <td class="test-td-header"> {{ $t("tests.dateResultsReceived") }} </td>
                      </tr>
                      <tr>
                        <td class="test-td-test-left"> {{ test.test }} </td>
                        <td class="test-td-test-center"> {{ test.dateOrdered }} <!--Date Ordered--></td>
                        <td class="test-td-test-center"> {{ test.datePerformed }} <!--Date Performed--></td>
                        <td class="test-td-test-center"> {{ test.dateOfResults }} <!--Date of Results--></td>
                        <td class="test-td-test-center"> {{ test.dateResultsReceived }} <!--Date Results Received--></td>
                      </tr>
                      <tr>
                        <td class="test-td-test-left" colspan="5">
                          <div style="height:10px" />
                          <br>
                          <input type="button" 
                            class="dialog-input-button" 
                            v-on:click="onHideShowTest(test.medicalTestId)"
                            v-bind:value="$t('tests.showHide')"><!--'Show / Hide Test Results'-->
                          <br>
                          <div style="height:10px" />
                        </td>
                      </tr>
                      <tr>
                        <td colspan="5">
                          <div :id="'div' + test.medicalTestId" class="is-hidden">
                            <table border="0" style="width:100%;max-width:100%;">
                              <tr>
                                <td class="test-td-test-item-header border-dots">{{ $t("tests.item") }} <!--Item--></td>
                                <td class="test-td-test-item-header border-dots">{{ $t("tests.flag") }} <!--Flag--></td>
                                <td class="test-td-test-item-header border-dots">{{ $t("tests.value") }} <!--Value--></td>
                              </tr>
                              <tr v-for="item in test.items" :key="item.medicalTestId">
                                <td class="test-td-test-item-left border-d"> {{ item.item }} </td>
                                <td class="test-td-test-item border-d"> {{ item.flag }} </td>
                                <td class="test-td-test-item border-d"> {{ item.value }} </td>
                              </tr>
                            </table> 
                          </div>
                          <!-- TEST ITEM FOOTER-->
                          <table border="0" style="width:100%;max-width:100%;">
                            <tr>
                              <td class="test-td-test-footer radius-single-left-field-left-bottom"></td>
                              <td class="test-td-test-footer" colspan="1"></td>
                              <td class="test-td-test-footer radius-single-right-field-right-bottom"></td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <div style="height:10px" />
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
            <!--<tr>
              <td class="test-td-test-left radius-single-left-field-left-bottom"></td>
              <td class="test-td-test-center"></td>
              <td class="test-td-test-center"></td>
              <td class="test-td-test-center"></td>
              <td class="test-td-test-center radius-single-right-field-right-bottom"></td>
            </tr>-->
          </table>
        </td>
      </tr>
      
      <!-- LOADING -->
      <tr>
        <td class="screen-table-td">
          <div id="loading" width="100%">
            <table class="section-table" border="0" align="center">
              <tr>
                <td class="section-border-top data-canvas radius-bottom-left-field-bottom radius-bottom-right-field-bottom">
                  <div style="height:30px;"></div>
                  <table border="0" align="center">
                    <tr>
                      <td class="instruction-field" colspan="2">
                        <div style="height:100px;"/>
                        <img src="../../../assets/images/working.gif" style="background-color:transparent;height:40px" >
                        <div style="height:100px;"/>
                      </td>
                    </tr>
                  </table>
                  <div style="height:40px;"></div>
                </td>
              </tr>
            </table>
          </div>
        </td>   
      </tr>
      <div style="height:20px"/>
    </table>
  </div>
</template>

<script>

import messageBox from '.././common/message-box'
const { API } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )
const { SUPPORT } = require( '../../../api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

export default {
  name: 'medical-test',
  data() {
    return {
      tests: [],
      //testsVisibility: [],
      testsLength:0,
      isMobile:false
    }
  },
  methods: 
  {
    load() {
      
      SUPPORT.showServiceMenus();
      document.getElementById('menuMedicalTests').classList.add('is-hidden');

      var loading = document.getElementById("loading");

      loading.style.display = "block";

      API.readMedicalTest(window.sessionKey, this.$i18n.locale)
      .then(response => {
        if(response.data.hasError == true)
        {
          //this.input.isLoading = false;
          this.$generalMessage(messageBox, response.data.errorMessage);
          SUPPORT.securityCheck(response.data.errorId);
        }
        else
        {
          this.tests = response.data.tests;
          this.testsLength = response.data.length;
          loading.style.display = "none";
        }
      }).catch( e =>
      {
        loading.style.display = "none";
        this.$generalMessage( messageBox, e );            
      })
    },
    onHideShowTest(divName)
    {
      var div = document.getElementById('div' + divName);
      div.classList.toggle('is-hidden');
      /* alert(div);
      if(div.classList.contians('is-hidden'))
      {
        document.getElementById('div' + divName).classList.remove('is-hidden');
      }
      else
      {
        document.getElementById('div' + divName).classList.add('is-hidden');
      } */
    }
  },
  mounted () {
    
    // SHOW TOP OF VIEW
    window.scrollTo(0, 0);

    this.load();
  },
  created() {
    if (screen.width <= 1023) {
        this.isMobile = true;
      } else {
        this.isMobile = false
      }
  }
}

</script>

<style lang="scss" scoped>
@import "../../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

// BEGIN SHARED STYLES
p {
  white-space: pre;
}
.border-dots
{
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:silver !important;
}

// END SHARED STYLES

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  .data-canvas
  {
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
  }
  .screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;
  }  
  #screen-row1
  {
    height:100%; 
  }
  .screen-table-td
  {
    margin:auto;
  }
  .section-table
  {
    width:96%;
  }
  #title-left
  {
    width:100%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align: middle;
    text-align: center;
  }
  #title-right
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  .border-m{
    border-bottom-style:dashed;
    border-bottom-width:1px !important;
    border-bottom-color:silver !important;
  }
  .test-td-header
  {
    width:100%;
    height:25px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    text-align: left;
    margin-bottom:0px;
    padding-top:0px;
    padding-left:5px;
    vertical-align: left;
  }
  .test-td-test-left
  {
    width:100%;
    height:40px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    //margin-left: 5px;
    vertical-align:middle !important;
    text-align: center;
    //padding-left: 5px;
  }
  .test-td-test-center
  {
    height:25px;
    width:100%;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .test-td-test-footer
  {
    height:25px;
    width:100%;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .test-td-test-item-header
  {
    height:25px;
    width:100%;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .test-td-test-item
  {
    overflow-wrap: anywhere;
    //height:35px;
    min-height: 35px;
    height:auto;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    padding-left:5px;
    padding-right:5px;
    margin-bottom:0px;
    vertical-align:top;
    text-align:left;
  }
  .test-td-test-item-left
  {
    overflow-wrap: anywhere;
    //height:35px;
    min-height: 35px;
    height:auto;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    padding-left:5px;
    padding-right:5px;
    margin-bottom:0px;
    vertical-align:top;
    text-align:left;
  }
  .instruction-field
  {
    //height:25px;
    vertical-align: top;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
    //padding-left: 10%;
    //padding-right: 10%;
  }
  .section-border-top
  {
    border-top-style: solid;
    border-top-color:#4682B4 ;
    border-top-width: 3px;
  }

  // CORNER SUPPORT 
 .radius-single-left-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    overflow:hidden;
  } 
  .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    overflow:hidden;
  }
  .radius-single-right-field-left-top
  {
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 
  // END CORNER SUPPORT
  .dialog-input-button
  {
    height:25px;
    text-align:left;
    vertical-align: middle;
    background-color:#775C9F;
    color:white;
    border-radius: 10px;
    border-width: 1px;
    border-color:darkgray;
  }
}
//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  .data-canvas
  {
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
  }
  #screen-row1
  {
    height:50px; 
  }
  .screen
  {
    width:100%;
    max-width:100%;
    min-width:100%;
    background-color:gray;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    display:table;
  }
  .screen-table-td
  {
    margin:auto;
  }
  .section-table
  {
    width:98%;
  }
  #title-left
  {
    width:20%;
    height:50px;
    background-color:#4682B4;
    color:white;
    font-family:'Arial Black';
    font-size: 17pt;
    font-style:italic;
    font-weight: bold;
    padding-bottom:0px;
    padding-left:15px ;
    margin-bottom:0px;
    vertical-align: middle;
  }
  #title-right
  {
    word-wrap:break-word !important;
    background-color:#4682B4;
    color:white;
    font-family:'Arial';
    font-size: 11pt;
    font-style:italic;
    padding-left:30px;
    padding-right:30px;
    vertical-align: middle;
  }
  .test-td-header
  {
    width:20% !important;
    height:20px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-bottom:0px;
    padding-top:10px;
    text-align: center;
    margin-bottom:0px;
    vertical-align: left;
  }
  .test-td-test-left
  {
    width:20%;
    height:25px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    padding-left: 15px;
    vertical-align:middle;
    text-align: left;
  }
  .test-td-test-center
  {
    
    height:25px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .test-td-test-footer
  {
    
    height:20px;
    background-color:#4682B4;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .test-td-test-item-header
  {
    height:25px;
    width:33%;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    font-weight: bold;
    padding-top:15px;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .test-td-test-item
  {
    overflow-wrap: anywhere;
    height:25px;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-left:5px;
    padding-right:5px;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: center;
  }
  .test-td-test-item-left
  {
    overflow-wrap: break-word;
    height:25px;
    background-color:#325775;
    color:white;
    font-family:'Lato';
    font-size: 11pt;
    font-style: normal;
    padding-left:5px;
    padding-right:5px;
    padding-bottom:0px;
    margin-bottom:0px;
    vertical-align:middle;
    text-align: left;
  }
  .border-d{
    border-bottom-style:solid;
    border-bottom-width:1px !important;
    border-bottom-color: darkcyan !important;
  }
  .instruction-field
  {
    height:25px;
    vertical-align: middle;
    text-align: center;
    background-color:#343F68;
    font-size: 24px;
    color:#6fa3ce;//white;
    font-family:Lato;
    font-weight:600; 
    padding-left: 10%;
    padding-right: 10%;
  }

  .section-border-top
  {
    border-top-style: solid;
    border-top-color:#4682B4 ;
    border-top-width: 3px;
  }

  // ******* CORNER SUPPORT *******
  .radius-single-left-field-left-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-left-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
 .radius-single-left-field-right-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-left-field-right-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  }

  .radius-single-right-field-left-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-left-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-single-right-field-right-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  }

  // TOP ROW
  .radius-top-left-field-top
  {
    border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-top-left-field-bottom
  {
    //border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-top-right-field-top
  {
    border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-top-right-field-bottom
  {
    //border-bottom-right-radius:15px;
    overflow:hidden;
  } 


  // BOTTOM ROW
  .radius-bottom-left-field-top
  {
    //border-top-left-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-left-field-bottom
  {
    border-bottom-left-radius:15px;
    overflow:hidden;
  } 
  .radius-bottom-right-field-top
  {
    //border-top-right-radius:15px;
    overflow:hidden;
  }
  .radius-bottom-right-field-bottom
  {
    border-bottom-right-radius:15px;
    overflow:hidden;
  } 
  .dialog-input-button
  {
    height:25px;
    vertical-align: middle;
    background-color:#775C9F;
    color:white;
    border-radius: 10px;
    border-width: 1px;
    border-color:darkgray;
  }
  // ******* END CORNER SUPPORT *******
}
</style>